var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 3,
    y: 6,
    fill: "none",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5 10v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8M10 14h4"
  })));
};
export default SvgArchive;